import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import SEO from "@/components/SEO";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data));
  }, []);

  return (
    <div className="fade-in" data-testid="page-blog">
      <SEO title="Creator Resources" description="Tutorials, gear guides, and audio tips for creators." path="/blog" />
      <section className="max-w-6xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-20">
        <p className="eyebrow mb-4">Creator Resources</p>
        <h1 className="text-h1 text-[#1D1D1F]">Better sound. Better content.</h1>
        <p className="mt-4 text-[#86868B] max-w-2xl">Tutorials, gear guides, and behind-the-scenes tips from the CreatorMic team.</p>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {posts.map((p) => (
            <Link key={p.id} to={`/blog/${p.slug}`} className="soft-card overflow-hidden group" data-testid={`blog-card-${p.slug}`}>
              <div className="aspect-[4/3] overflow-hidden">
                <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-6">
                <div className="flex gap-2 mb-3">
                  {p.tags.slice(0, 2).map((t) => <span key={t} className="text-[10px] uppercase tracking-widest text-[#0066FF]">{t}</span>)}
                </div>
                <h3 className="font-display text-lg font-bold text-[#1D1D1F] leading-tight">{p.title}</h3>
                <p className="mt-2 text-sm text-[#86868B] line-clamp-3">{p.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
